import { Component, Input, ModuleWithProviders, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { InstantChartApiService } from '@reenstudio/app/core/services/charts-api/instant-api-service';
import { EventService } from '@reenstudio/app/core/services/event-service';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { UserService } from '@reenstudio/app/core/services/user-service';
import { NgCircleProgressModule } from 'ng-circle-progress';

@Component({
  selector: 'app-consumed-energy',
  templateUrl: './consumed-energy.component.html',
  styleUrls: ['./consumed-energy.component.scss'],
  standalone: true,
  imports: [MatCardModule, NgCircleProgressModule],
  providers: [
    (
      NgCircleProgressModule.forRoot(
        {}
      ) as ModuleWithProviders<NgCircleProgressModule>
    ).providers!,
  ],
})
export class ConsumedEnergyComponent implements OnInit {
  @Input() consumed: any;
  @Input() shared: any;
  @Input() type: 'dashboard' | 'history';

  sharedEnergy: any;

  chart: any = {};

  constructor(
    private apiService: InstantChartApiService,
    private storageService: StorageService
  ) {}

  async ngOnInit() {
    let cer: number | null = 0;
    let site: number | null = 0;

    cer = this.storageService.getCer();

    if (this.storageService.getLevel() === UserRole.SITE) {
      site = this.storageService.getSite();
    }

    if (this.type === 'dashboard') {
      this.apiService.getIstant(cer, site).subscribe((data) => {
        this.shared = (data.tot_extraction_shared / 1000).toFixed(2);
        this.consumed = (data.tot_extraction / 1000).toFixed(2);

        this.chart = {
          percent: this.getSharedEnergy(),
          toFixed: 0,
          radius: 120,
          space: 0,

          title: 'Prelevat dalla rete',
          showTitle: false,
          subtitle: this.consumed + ' kW',

          titleFontSize: 17,
          titleColor: '#CCC',
          subtitleFontSize: 25,
          subtitleColor: '#000',
          showUnits: false,

          outerStrokeWidth: 12,
          outerStrokeColor: '#6dcceb',
          innerStrokeColor: '#3965cc',
          innerStrokeWidth: 23,
          showBackground: false,
          responsive: false,
        };
      });
    } else if (this.type === 'history') {
      this.chart = {
        percent: this.getSharedEnergy(),
        toFixed: 0,
        radius: 120,
        space: 0,

        title: 'Prelevat dalla rete',
        showTitle: false,
        subtitle: this.consumed + ' kWh',

        titleFontSize: 17,
        titleColor: '#CCC',
        subtitleFontSize: 25,
        subtitleColor: '#000',
        showUnits: false,

        outerStrokeWidth: 12,
        outerStrokeColor: '#6dcceb',
        innerStrokeColor: '#3965cc',
        innerStrokeWidth: 23,
        showBackground: false,
        responsive: false,
      };
    }

    EventService.changeCer.subscribe(() => {
      this.ngOnInit();
    });

    EventService.changeSite.subscribe(() => {
      this.ngOnInit();
    });
  }

  getSharedEnergy() {
    const sharedPercentage = (this.shared * 100) / this.consumed;

    // console.log(this.shared);
    // console.log(this.consumed);

    return sharedPercentage.toFixed(0);
  }
}
